import { useEffect, useState } from "react";

import { api } from "../../services/api";
import { Body, MainTable, MainText } from "./RankingsElements";
import { Table, InputPicker } from "rsuite";

type FirstRankingProps = {
  estado: string;
  municipio: string;
  cod_ibge: string;
  populacao: number;
  dose1: number;
  dose2: number;
  dose3: number;
  doses_aplicadas: number;
  doses_distribuidas: number;
  doses_aplicadas_por_distribuidas: number;
  pop_vacinada_dose1_por_total: number;
  pop_vacinada_dose2_por_total: number;
  pop_vacinada_por_total: number;
  pop_vacinada_dose3_por_total: number;
  area: string;
  postos: number;
  estoque: number;
  media_movel: number;
  classificacao_vacinacao: string;
  ranking_estado: number;
  regiao: string;
  ranking_regiao: number;
  qtd_municipios_regiao: number;
  ranking_similares: number;
  populacao_maior_5: number;
  pop_vacinada_dose1_por_pop_maior_5: number;
  pop_vacinada_dose2_por_pop_maior_5: number;
  pop_vacinada_dose3_por_pop_maior_5: number;
  pop_vacinada_por_pop_maior_5: number;
  populacao_maior_10: number;
  pop_vacinada_dose1_por_pop_maior_10: number;
  pop_vacinada_dose2_por_pop_maior_10: number;
  pop_vacinada_dose3_por_pop_maior_10: number;
  pop_vacinada_por_pop_maior_10: number;
  populacao_maior_15: number;
  pop_vacinada_dose1_por_pop_maior_15: number;
  pop_vacinada_dose2_por_pop_maior_15: number;
  pop_vacinada_dose3_por_pop_maior_15: number;
  pop_vacinada_por_pop_maior_15: number;
  data_atualizacao_vacinacao: string;
  data_atualizacao_distribuicao: string;
  data_atualizacao: string;
  array_pop_vacinada_dose1: [number];
  array_pop_vacinada_dose2: [number];
  array_pop_vacinada_dose3: [number];
  array_total_dose3: [number];
  array_total_dose1: [number];
  array_total_dose2: [number];
  id?: number;
};

export default function Rankings() {
  const [FirstRanking, setFirstRanking] = useState<FirstRankingProps[]>();
  const [tempData, setTempData] = useState<FirstRankingProps[]>();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedType, setSelectedType] = useState("sortByDose1");
  const [sortColumn, setSortColumn] = useState();
  const [sortType, setSortType] = useState();
  const [loading, setLoading] = useState(false);
  const [country, setCountry] = useState("SP");

  const states = [
    {
      label: "Minas Gerais",
      value: "MG",
      role: "MG",
    },
    {
      label: "São Paulo",
      value: "SP",
      role: "SP",
    },
  ];

  useEffect(() => {
    //alterar SP para o estado em questão
    api.get(`/all_cities/${country}/overview`).then((res) => {
      console.log(res);
      const data = res.data.map((elem: FirstRankingProps) => {
        const dose1 = Number(
          elem.array_pop_vacinada_dose1[
            elem.array_pop_vacinada_dose1.length - 1
          ].toFixed(2)
        );
        const dose2 = Number(
          elem.array_pop_vacinada_dose2[
            elem.array_pop_vacinada_dose2.length - 1
          ].toFixed(2)
        );
        const dose3 = Number(
          elem.array_pop_vacinada_dose3[
            elem.array_pop_vacinada_dose3.length - 1
          ].toFixed(2)
        );
        const popEstimada = Math.round(
          (elem.array_total_dose3[elem.array_total_dose3.length - 1] * 100) /
            Number(
              elem.array_pop_vacinada_dose3[
                elem.array_pop_vacinada_dose3.length - 1
              ].toFixed(2)
            )
        ).toLocaleString("pt-br");
        const popEstimadaValue = Math.round(
          (elem.array_total_dose3[elem.array_total_dose3.length - 1] * 100) /
            Number(
              elem.array_pop_vacinada_dose3[
                elem.array_pop_vacinada_dose3.length - 1
              ].toFixed(2)
            )
        );
        const municipio = elem.municipio;
        return {
          dose1,
          dose2,
          dose3,
          popEstimada,
          popEstimadaValue,
          municipio,
        };
      });
      setFirstRanking(data);
      setIsLoading(false);
    });
  }, [country]);

  const getData = () => {
    const getSort = () => {
      if (sortColumn && sortType) {
        //@ts-ignore
        return FirstRanking.sort((a, b) => {
          let x = a[sortColumn];
          let y = b[sortColumn];
          if (typeof x === "string") {
            //@ts-ignore
            x = x.charCodeAt();
          }
          if (typeof y === "string") {
            //@ts-ignore
            y = y.charCodeAt();
          }
          if (sortType === "asc") {
            if (sortColumn === "popEstimada") {
              //@ts-ignore
              return a.popEstimadaValue - b.popEstimadaValue;
            }
            return x - y;
          } else {
            if (sortColumn === "popEstimada") {
              //@ts-ignore
              return b.popEstimadaValue - a.popEstimadaValue;
            }
            return y - x;
          }
        });
      }
      return FirstRanking;
    };

    return getSort()?.map((elem, index) => {
      elem.id = index + 1;
      return elem;
    });
  };

  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };

  return (
    <>
      <Body>
        {/* @ts-ignore */}
        {isLoading === false && (
          <>
            <MainText>
              Tabela filtrada pelo estado:{" "}
              <span>{country === "SP" ? "São Paulo" : "Minas Gerais"}</span>
            </MainText>
            <InputPicker
              onChange={(e) => {
                setCountry(e);
              }}
              data={states}
              style={{ width: 224, marginLeft: 100, marginBottom: 20 }}
            />
            <MainTable>
              <Table
                height={400}
                width={1000}
                //@ts-ignore
                data={getData()}
                sortColumn={sortColumn}
                onSortColumn={handleSortColumn}
                sortType={sortType}
                loading={loading}
                onRowClick={(data) => {
                  console.log(data);
                }}
              >
                <Table.Column width={100} align="center" fixed>
                  <Table.HeaderCell>Posição</Table.HeaderCell>
                  <Table.Cell dataKey="id" />
                </Table.Column>
                <Table.Column width={300} align="center" fixed>
                  <Table.HeaderCell>Municipio</Table.HeaderCell>
                  <Table.Cell dataKey="municipio" />
                </Table.Column>

                <Table.Column width={130} fixed sortable>
                  <Table.HeaderCell>Dose 1 %</Table.HeaderCell>
                  <Table.Cell dataKey="dose1" />
                </Table.Column>

                <Table.Column width={130} sortable>
                  <Table.HeaderCell>Dose 2 %</Table.HeaderCell>
                  <Table.Cell dataKey="dose2" />
                </Table.Column>

                <Table.Column width={200} sortable>
                  <Table.HeaderCell>Dose 3 %</Table.HeaderCell>
                  <Table.Cell dataKey="dose3" />
                </Table.Column>

                <Table.Column width={200} sortable>
                  <Table.HeaderCell>Company Name</Table.HeaderCell>
                  <Table.Cell dataKey="popEstimada" />
                </Table.Column>
              </Table>
            </MainTable>
          </>
        )}
      </Body>
    </>
  );
}
